// extracted by mini-css-extract-plugin
module.exports = {"lotteryImage":"_23rT9YfQENMRGBeWes7h6z"};